module.exports = __webpack_public_path__ + "img/Moderator_Up_arrow.6db8800f.svg";